import * as SavelendActions from "./actions";
import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    savelendSpecialAccountOrders:
      state.savelendMoneyReducer.savelendSpecialAccountOrders,
    savelendSpecialAccountBalance:
      state.savelendMoneyReducer.savelendSpecialAccountBalance,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    savelendReceiveSpecialAccountOrders: () => {
      dispatch(SavelendActions.get_savelend_special_account_orders());
    },
    savelendPostSpecialAccountWithdrawalOrder: (
      Account,
      Currency,
      Amount,
      Notes,
    ) => {
      dispatch(
        SavelendActions.create_savelend_account_withdrawal_order(
          Account,
          Currency,
          Amount,
          Notes,
        ),
      );
    },
    savelendPostSpecialAccountDepositOrder: (
      Account,
      Currency,
      Amount,
      Notes,
    ) => {
      dispatch(
        SavelendActions.create_savelend_account_deposit_order(
          Account,
          Currency,
          Amount,
          Notes,
        ),
      );
    },
    savelendPostConfirmSpecialAccountOrder: (Id) => {
      dispatch(SavelendActions.confirm_savelend_special_account_order(Id));
    },
    savelendPostCancelSpecialAccountOrder: (Id) => {
      dispatch(SavelendActions.cancel_savelend_special_account_order(Id));
    },
  };
}

export const savelendConnector = connect(mapStateToProps, mapDispatchToProps);
